import { Component, OnInit } from '@angular/core';

// Models
import { User } from '../../models/user.model';

// Services
import { UserSessionService } from '../../services/user/user.service';
import { SidebarService } from '../../services/shared/sidebar.service';
import { SettingsService } from '../../services/settings/settings.service';
import { LanguageService } from '../../services/language/language.service';
import { MixpanelService } from 'src/app/services/analytics/mixpanel.service';
import { RouterLinkActive, RouterLink } from '@angular/router';

/**
 * Component that shows a footer on responsive only
 */
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  imports: [RouterLinkActive, RouterLink],
})
export class FooterComponent implements OnInit {
  /**
   * Se declara la variable color
   * @param color Variable para guardar el color
   */
  color: string;
  /**
   * Se declara la variable theme
   * @param theme Variable para guardar el tema de la página
   */
  theme?: string;
  /**
   * Se declara la variable language
   * @param language Variable para guardar el idioma
   */
  language: string;
  /**
   * Se declara la variable user
   * @param user Variable para guardar los datos del usuario
   */
  user!: User;
  userId = this.UserSessionService.getId();

  /**
   * Following variables declared
   * @param UserSessionService Service that brings users data and functions
   * @param settings Service that works the page colour
   * @param sidebarService Service that works with the sidebar and the app of the page
   * @param languageService Service that works with the page language
   */
  constructor(
    public UserSessionService: UserSessionService,
    public settings: SettingsService,
    public sidebarService: SidebarService,
    public languageService: LanguageService,
    public mixpanelService: MixpanelService,
  ) {
    this.color = settings.getColor();
    this.language = languageService.getLanguage();
  }

  /**
   * Data is saved in the {@link ../injectables/UserSessionService.html|UserSessionService.user} on the user variable
   */
  ngOnInit() {
    this.user = this.UserSessionService.user;
  }

  /**
   * Function that applies colour, changing the app and at the end, reloads to make the new requests
   * @param theme Variable that brings colour to apply according to the user selection
   */
  changeColor(theme: string) {
    this.theme = theme;
    this.settings.applyTheme(this.theme);
    this.color = this.settings.getColor();
    if (this.color === 'red') {
      this.sidebarService.applyApp('LAB4PHYSICS');
    } else {
      this.sidebarService.applyApp('LAB4CHEMISTRY');
    }
    window.location.reload();
  }

  footerShowSection(section_title: string) {
    this.mixpanelService.track(
      `footer_show_section_${section_title.slice(1)}`,
      { 'User type': this.UserSessionService.getRole() },
    );
  }
}
